import LoyaltyProgramAuthenticatedSFC from "./LoyaltyProgramAuthenticated.vue";
export const LoyaltyProgramAuthenticated = LoyaltyProgramAuthenticatedSFC;
